import { render, staticRenderFns } from "./shift-auth-history.vue?vue&type=template&id=2989ae30&scoped=true"
import script from "./shift-auth-history.vue?vue&type=script&lang=js"
export * from "./shift-auth-history.vue?vue&type=script&lang=js"
import style0 from "./shift-auth-history.vue?vue&type=style&index=0&id=2989ae30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2989ae30",
  null
  
)

export default component.exports